import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

export default class Panel extends Component {
  static propTypes = {
    title: PropTypes.string
  };

  render() {
    return (
      <Wrapper clasName={this.props.className}>
        <Title>{this.props.title}</Title>
        {this.props.children}
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;
const Title = styled.div`
  font-size: 1.1rem;
  color: black;
  padding-bottom: 12px;
  border-bottom: 1px solid ${props => props.theme.panelBorder};
`;



// WEBPACK FOOTER //
// ./src/module-agent-management/Panel.js